export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/rene-profile-2950fe5b584e0553b2a8cbcc6fef4e2d.png";